import Content from "uxp-documentation/src/pages/uxp-api/reference-html/Hierarchy/h6";
import * as React from 'react';
export default {
  Content,
  React
};